module.exports = __webpack_public_path__ + "img/saks4.a36cd9b7.jpg";